import { forwardRef, useImperativeHandle } from 'react';
import { Row, Col, Form, Skeleton, Checkbox } from 'antd';
import { FloatingFormItem } from '@/components/_common';
import { CompanySettingsFormValues } from '@/core/domain/enterprise/Companies/Companies.types';

interface CompanyMichelinFormProps {
  isLoading: boolean;
}

export interface CompanyMichelinRef {
  setFieldsValue: (values: Partial<CompanySettingsFormValues>) => void;
  validateFields: () => Promise<CompanySettingsFormValues>;
}

const CompanyMichelinForm = forwardRef<
  CompanyMichelinRef,
  CompanyMichelinFormProps
>(({ isLoading }, ref) => {
  const [form] = Form.useForm<CompanySettingsFormValues>();

  useImperativeHandle(ref, () => ({
    setFieldsValue: (values) => form.setFieldsValue(values),
    validateFields: () => form.validateFields(),
  }));

  return (
    <Form layout="horizontal" form={form} name="companyMichelin">
      <Skeleton active loading={isLoading}>
        <Row gutter={[16, 8]}>
          <Col span={24}>
            <FloatingFormItem
              valuePropName="checked"
              name="michelinIntegration"
            >
              <Checkbox>
                Essa empresa envia informações solicitadas pela Michelin
              </Checkbox>
            </FloatingFormItem>
          </Col>
        </Row>
      </Skeleton>
    </Form>
  );
});

export default CompanyMichelinForm;
